// @flow

import type { FuelInfo } from '../../../types';
import { type State } from '../reducers';
import { getComponentSettings } from './main';


type GlobalState = {
  componentSettings: State,
};

export type SpecificationSettings = $PropertyType<State, 'pdb_specs'>;
export const getSpecificationSettings = (state: GlobalState): SpecificationSettings => {
  const specifications = getComponentSettings(state).pdb_specs;
  if (!specifications) {
    throw new Error('Missing pdb_specs settings in componentSettings store.');
  }
  return specifications;
};

type Title = $PropertyType<SpecificationSettings, 'title'>;
export const getTitle = (state: GlobalState): Title => (
  getSpecificationSettings(state).title
);

type Keys = $PropertyType<SpecificationSettings, 'keys'>;
export const getKeys = (state: GlobalState): Keys => (
  getSpecificationSettings(state).keys
);

export const getFuelInfo = (state: GlobalState): ?FuelInfo => (
  getSpecificationSettings(state).fuelinfo || null
);

type Doors = $PropertyType<SpecificationSettings, 'doors'>;
export const getDoors = (state: GlobalState): Doors => (
  getSpecificationSettings(state).doors
);
